/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader, Textarea } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { TeacherGroupService, TeacherStudentSerivce } from '../../../services';
import DebouncedSearch from '../../../components/input-debounce';

const ModalCreateNotification = ({ item, onSuccess, onClose }) => {
  const { fetchData, form, isLoading, onChange, onSelectParent, onSubmit } = useForm(item);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  const parents = useMemo(() => {
    return form.parents.map(x => x?.fullname).join(', ');
  }, [form.parents]);

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Nueva notificación</ModalHeader>
      <ModalBody className="gap-4">
        <DebouncedSearch
          refresh={false}
          fetchFunction={fetchData}
          debounceTime={700}
          onSelect={onSelectParent}
          renderItem={item => {
            const isSelected = form.parents.some(x => x.id === item.id);
            return (
              <div className="flex gap-2 items-center">
                {isSelected
                  ? <div className="w-4 h-4 rounded-full border-1 border-[#00d17e] bg-[#00d17e]" />
                  : <div className="w-4 h-4 rounded-full border-1 border-gray" />
                }
                <span>{item.fullname} ({item.document_type?.name}{item.document})</span>
              </div>
            )
          }}
          onClickLabel={() => ''}
          value=""
          placeholder="Buscar representante"
        />

        {!!parents && (
          <p className="text-sm font-semibold text-black/80">
            <span className="text-red cursor-pointer mr-2" onClick={() => onChange([], 'parents')}>Limpiar </span>
            { parents }
          </p>
        )}

        <Textarea
          placeholder="Escribir"
          radius="sm"
          variant="bordered"
          value={form.body}
          onValueChange={v => onChange(v, 'body')}
        />
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose} isDisabled={isLoading}>
          Cancelar
        </Button>
        <Button className="bg-green" color="primary" onPress={submit} isLoading={isLoading} isDisabled={isLoading}>
          Enviar
        </Button>
      </ModalFooter>
    </>
  )
}

const useForm = () => {
  const initialForm = {
    body: '',
    all_parents: false,
    parents: [],
  };

  const user = useSelector(state => state.user);
  const [canFetch, setCanFetch] = useState(true);
  const [form, setForm] = useState(initialForm);

  const fetchData = async (search) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const filters = {
        user_id: user?.id,
        search,
      };
      const response = await TeacherStudentSerivce.student.getProfessorRepresentatives(filters);

      setCanFetch(true);
      return response;

    } catch (error) {
      toast.error(String(error));
      return [];
    }
  }

  const onSelectParent = (item) => {
    if (!item) return;
    const exists = form.parents.some(x => x.id === item.id);

    if (exists) {
      const others = form.parents.filter(x => x.id !== item.id);
      setForm(s => ({ ...s, parents: others }));
    } else {
      setForm(s => ({ ...s, parents: [...form.parents, item] }));
    }
  }

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const isValidForm = () => {
    const onError = (msg) => {
      toast.error(msg);
      return false;
    }

    if (!form.all_parents && !form.parents.length)
      return onError('Debe indicar al menos un representante');

    if (!form.body)
      return onError('Debe indicar el mensaje');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;

    try {
      const data = {
        ...form,
        professor_id: user?.id,
        parents: form.parents.map(x => ({ parent_id: x.id })),
      };

      await TeacherGroupService.groups.createNotification(data);
      toast.success('Notificación creada correctamente');
      return true;

    } catch (error) {
      toast.error(String(error?.message ?? error));
      return false;
    }
  }

  return {
    fetchData,
    form,
    isLoading: !canFetch,
    onChange,
    onSelectParent,
    onSubmit,
  }
}

export default ModalCreateNotification;
